import { createSelector } from '@reduxjs/toolkit';
import { State } from './types';
import { RootState } from '../root-reducer';

const rootSelector = (state: RootState): State => state.ServicesPassengersConcernedByCommunication;

export const ServicesPassengersConcernedByCommunicationStatusSelector = createSelector(
  rootSelector,
  (rootValue) => rootValue.status
);
export const ServicesPassengersConcernedByCommunicationErrorSelector = createSelector(
  rootSelector,
  (rootValue) => rootValue.error
);
export const ServicesPassengersConcernedByCommunicationErrorMessageSelector = createSelector(
  rootSelector,
  (rootValue) => rootValue.data?.message
);
export const ServicesPassengersConcernedByCommunicationDataSelector = createSelector(
  rootSelector,
  (rootValue) => rootValue.data?.totalPassengers
);

export default {
  ServicesPassengersConcernedByCommunicationStatusSelector,
  ServicesPassengersConcernedByCommunicationErrorSelector,
  ServicesPassengersConcernedByCommunicationErrorMessageSelector,
  ServicesPassengersConcernedByCommunicationDataSelector,
};
